// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"5745a9e8","208":"bb210eb5","488":"224a06ee","530":"3e3a2465","549":"81c63d5e","573":"c7917ba3","695":"a28374f7"}[chunkId] + ".css";
};